import { useInstance } from "@meraki-internal/react-dependency-injection";
import { ClubState, IVolunteerMediaType } from "../clubs/ClubsState";
import { IonButton, IonContent, IonHeader, IonModal, IonTitle, IonToolbar } from "@ionic/react";
import { VolunteerCard } from "./VolunteerCard";
import { State, useSubscription } from "@meraki-internal/state";
import { VolunteerCardForm } from "./VolunteerCardForm";

// TODO: move me
export class VolunteerModalState extends State<Record<string, never>>{
    constructor(){
        super({});
    }

    isOpen = false;
    editingVolunteer?: IVolunteerMediaType;
    open = (volunteer?: IVolunteerMediaType) => {
        this.isOpen = true;
        this.editingVolunteer = volunteer;
        this.setState({ });
    }
    close = () => {
        this.isOpen = false;
        this.editingVolunteer = undefined;
        this.setState({ });
    }
}

const modalHeight = 800;

const AddVolunteerModal: React.FC = () => {
    const modal = useInstance(VolunteerModalState);
    useSubscription(() => modal);

    const isOpen = modal.isOpen && !modal.editingVolunteer;

    return (
        <IonModal isOpen={isOpen} onDidDismiss={modal.close} style={{ '--height': `${modalHeight}px` }}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Add Volunteer</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <VolunteerCardForm onSaved={modal.close} onCancel={modal.close} />
            </IonContent>
        </IonModal>
    )
}

const EditVolunteerModal: React.FC = () => {
    const modal = useInstance(VolunteerModalState);
    useSubscription(() => modal);

    const isOpen = modal.isOpen && Boolean(modal.editingVolunteer);

    return (
        <IonModal isOpen={isOpen} onDidDismiss={modal.close} style={{ '--height': `${modalHeight}px` }}>
            <IonHeader>
                <IonToolbar>
                    <IonTitle>Edit Volunteer</IonTitle>
                </IonToolbar>
            </IonHeader>
            <IonContent>
                <VolunteerCardForm onSaved={modal.close} volunteer={modal.editingVolunteer} onCancel={modal.close} />
            </IonContent>
        </IonModal>
    )
}

export const VolunteerList: React.FC<{ clubId: string; }> = ({ clubId }) => {
    const clubState = useInstance(ClubState);
    const modal = useInstance(VolunteerModalState);

    const add = async () => {
        modal.open();
        // clubState.addVolunteer();
    }
    return (
        <>
            <IonButton onClick={add}>Add Volunteer</IonButton>
            <div style={{ display: 'flex', flexWrap: 'wrap', justifyContent: 'space-evenly'}}>
                {clubState.getVolunteers().map(v => (
                    <VolunteerCard key={v.volunteerId} volunteer={v} />
                ))}
            </div>

            <AddVolunteerModal />
            <EditVolunteerModal />
        </>
    );
}
